"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupFetch = void 0;
const atom_1 = require("../../atom");
const modifySP = (sp, $CustomSP) => {
    const { region } = window.store.get(atom_1.$Locale);
    const { clientBuildVariant } = window.store.get(atom_1.$RenderConfig);
    sp.set('region', region);
    if (clientBuildVariant !== atom_1.DEFAULT_CLIENT_BUILD_VARIANT) {
        sp.set(atom_1.CLIENT_BUILD_VARIANT_QUERY, clientBuildVariant);
    }
    if ($CustomSP) {
        const customSP = window.store.get($CustomSP);
        Object.entries(customSP).forEach(([key, value]) => {
            sp.set(key, value);
        });
    }
};
const setupFetch = ($CustomSP) => {
    const originFetch = window.fetch;
    window.fetch = (input, init) => {
        if (typeof input === 'string') {
            const u = new URL(input, location.href);
            if (u.hostname !== location.hostname) {
                return originFetch(input, init);
            }
            modifySP(u.searchParams, $CustomSP);
            input = u.toString();
        }
        else if (input instanceof URL) {
            if (input.hostname !== location.hostname) {
                return originFetch(input, init);
            }
            modifySP(input.searchParams, $CustomSP);
        }
        else if (input instanceof Request) {
            const u = new URL(input.url, location.href);
            if (u.hostname !== location.hostname) {
                return originFetch(input, init);
            }
            modifySP(u.searchParams, $CustomSP);
            input = new Request(u.toString(), input);
        }
        return originFetch(input, init);
    };
};
exports.setupFetch = setupFetch;
